{
  "appName": "Conflicting Interests Certification For Proprietary Schools",
  "entryFile": "./app-entry.jsx",
  "entryName": "1919-edu-benefits",
  "rootUrl": "/school-administrators/report-conflicting-interests",
  "productId": "b13f499a-24f7-4ff7-bf94-8c0dbe38a0e1"
}
